/*
 * Lib Module Flash
 * TODO Stop using jGrowl, make own using a script template, its not much
 */

class Flash extends LibModule {
    constructor() {
        super();
    }

    DOMReady() {

        const self = this;

        if ('options' in Lib && 'flash' in Lib.options && Lib.options.flash) {
            var msg = Lib.Util.getOption('flash.message');
            if (msg) {
                self.msg(msg, {
                    sticky: !Lib.options.flash.autoClose,
                    theme: 'notification-' + Lib.options.flash.color
                });
            }
        }

        $(document).on('click', '[data-flash-close]', function() {
            $("#jGrowl").find('.jGrowl-notification').trigger('click');
        });
    }

    msg(msg, options_) {

        let flashHolder = $("#flash-holder");
        if (flashHolder.length === 0) {
            flashHolder = document.body;
        }

        let options = $.extend(true, {
            sticky: false,
            theme: 'notification-green',
            position: 'center',
            life: 5000,
            pool: 1,
            appendTo: flashHolder,
            click: function(e) {
                $(e).fadeOut(200);
            }
        }, options_);

        $.jGrowl(msg, options);
    }
}

Lib.Flash = new Flash;
